import { makeAutoObservable } from 'mobx';

class MidiStore {
  inputs: { id: string; name: string }[] = [];
  outputs: { id: string; name: string }[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setInputs(inputs: { id: string; name: string }[]) {
    this.inputs = inputs;
  }

  setOutputs(outputs: { id: string; name: string }[]) {
    this.outputs = outputs;
  }

  refresh(managerEntity: any) {
    if (!managerEntity?.webmidi) return;
    this.setInputs([...(managerEntity.webmidi.inputs?.values() ?? [])]);
    const outputs = [...(managerEntity.webmidi.outputs?.values() ?? [])];
    outputs.push({ name: 'WebAudioFontOutput', id: 'WebAudioFontOutput' });
    outputs.push({ name: 'MIDIJS', id: 'MIDIJS' });
    this.setOutputs(outputs);
  }
}

export const midiStore = new MidiStore();
